import { useState } from "react";
import CustomDataGridV2 from "../../../../components/CustomDataGridV2";
import useCurrentUser from "../../../../hooks/local-storage/use-current-user";
import { usePatientPortalVaccineListHealthRecord } from "../../../../queries/vaccines/use-patient-vaccines-list-health-record";
import { formatDate } from "../../../../utils/date-time-utility";
import {
  DEF_PAGINATION,
  DGT_Pagination,
  getXtenantId,
} from "../../../../utils/utils";

const PatientPortalImmunization = () => {
  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [currentUser] = useCurrentUser();

  const { data: vaccineList } = usePatientPortalVaccineListHealthRecord({
    patientUuid: currentUser?.uuid ?? "",
    pagination,
    xTENANTID: getXtenantId() ?? undefined,
  });

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      renderCell: ({ value }: any) => value ?? "-",
    },
    {
      field: "administerDate",
      headerName: "Administered Date",
      flex: 1,
      renderCell: ({ value }: any) => (value ? formatDate(value) : "-"),
    },
    {
      field: "administerBy",
      headerName: "Administered By",
      flex: 1,
      renderCell: ({ value }: any) => value ?? "-",
    },
    // {
    //   field: "active",
    //   headerName: "Status",
    //   flex: 1,
    //   renderCell: ({ value }: any) => (value ? "Active" : "Inactive"),
    // },
  ];

  return (
    <CustomDataGridV2
      getRowId={(row) => row?.uuid}
      rows={vaccineList?.content ?? []}
      rowCount={vaccineList?.page?.totalElements ?? 0}
      columns={columns}
      paginationModel={pagination}
      onPaginationModelChange={setPagination}
    />
  );
};

export default PatientPortalImmunization;
